<template>
    <div>
        <c-card-iterator
            :items          = "items"
            :label          = "$t('todo.guard.failed.title2')"
            :loading        = "loading"
            :title-prefix   = "true"
            :pagination-on  = "true"
            :item-height    = "76"
            :min-height     = "topHeight"
            :filter         = "match"
            :filter-height  = "72"
            :height         = "null"
        >
            <template v-slot:card="{ item }">
                <p-inc-guard-protocol-failed-card
                    :protocol = "item"
                    @assign   = "onAssign"
                    @delete   = "onDelete"
                />
            </template>
        </c-card-iterator>
    </div>
</template>

<script>

import Core                        from "@/modules/core/service/Core";
import CCardIterator               from "@/modules/core/components/utils/CCardIterator.vue";
import GuardProtocol               from "@/modules/inc/todos/service/GuardProtocol";
import PIncGuardProtocolFailedCard from "@/modules/inc/todos/components/private/PIncGuardProtocolFailedCard.vue";

export default {
    name: "PIncGuardProtocolFailedIterator",

    components: {
        PIncGuardProtocolFailedCard,
        CCardIterator
    },

    props: {
        topHeight: {

        },

        customer: {

        },

        all: {

        },

        liftmanagement: {

        }
    },

    data: () => ({
        items  : null,
        loading: false,
    }),

    mounted () {
        this.initialize();
    },

    methods: {
        initialize () {
            GuardProtocol.findFailed(this.customer).then (data => {
                this.items = data;
            })
        },

        onAssign (event) {
            console.log("onAssign", event)
            GuardProtocol.assign(event.protocol, event.unit).then(() => {
                this.removeProtocol(event.protocol);
                this.$emit("assigned", event.protocol);
                Core.message.hint(this, this.$t("todo.guard.assign.success"));
            });
        },

        onDelete (protocol) {
            GuardProtocol.delete (protocol).then (() => {
                this.removeProtocol(protocol);
                this.$emit("assigned", protocol);
                Core.message.hint(this, this.$t("todo.guard.delete.success"))
            });
        },

        match () {
            return true;
        },

        removeProtocol (protocol) {
            const index = this.items.findIndex(item => item.id === protocol.id);
            if (index >= 0) {
                this.items.splice(index, 1);
            }
        }
    }
}
</script>

<style scoped>

</style>